import { useCallback, useState } from 'react';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

type Tuple = [boolean, (value: boolean) => void];

const userLocalStorage = createLocalStorageProvider('jira-issue-view-expandable-child-issues');

export const getGroupLocalStorageName = (projectKey: string, id: string) =>
	`group.state.${projectKey}.${id}`;

export const getGroupLocalStorage = (keyName: string, defaultValue: boolean) => {
	const item = userLocalStorage.get(keyName);
	if (item === 'true') return true;
	if (item === 'false') return false;
	return defaultValue;
};

export const isGroupPanelOpen = (
	projectKey: string,
	group: string,
	panelId: string,
	defaultValue: boolean,
) => {
	const groupLocalStorageName = getGroupLocalStorageName(projectKey, group);

	return getGroupLocalStorage(`${groupLocalStorageName}-${panelId}`, defaultValue);
};

export const getGroupsLocalStorage = (keyNames: string[], initialOpened: boolean) => {
	const items: { [key: string]: boolean } = {};
	keyNames.forEach((key) => {
		items[key] = getGroupLocalStorage(key, initialOpened);
	});

	return items;
};

export const useGroupLocalStorage = (
	projectKey: string,
	id: string,
	initialOpened: boolean,
): Tuple => {
	const keyName = getGroupLocalStorageName(projectKey, id);
	const [storedValue, setStoredValue] = useState(() =>
		getGroupLocalStorage(keyName, initialOpened),
	);

	const setValue = useCallback(
		(value: boolean) => {
			try {
				setStoredValue(value);

				userLocalStorage.set(keyName, String(value));
			} catch (_) {
				// Not decided what we do when we reach here.
			}
		},
		[keyName],
	);

	return [storedValue, setValue];
};
